import { useState } from 'react'
import isEqual from 'lodash-es/isEqual'

export function useTableModalCloseHandler({
  initialSelectionValues,
  selectAllPages,
  selected,
  onClose,
}) {
  const [isCloseConfirm, setCloseConfirm] = useState(false)

  function handleCloseTableModal() {
    if (!isEqual(initialSelectionValues, selected) || selectAllPages) {
      setCloseConfirm(true)

      return
    }

    onClose()
  }

  return {
    handleCloseTableModal,
    isCloseConfirm,
    setCloseConfirm,
  }
}
